import React, { useMemo } from 'react';
import { cv } from '../../Data';

function toTags(techStack) {
  if (!techStack) return [];
  return techStack
    .split(/•|·|,|\||\//g)
    .map((s) => s.trim())
    .filter(Boolean)
    .slice(0, 10);
}

const Resume = () => {
  const experience = useMemo(() => cv.filter((c) => c.category === 'experience'), []);
  const education = useMemo(() => cv.filter((c) => c.category === 'education'), []);

  return (
    <section
      id="resume"
      className="relative overflow-hidden bg-gradient-to-b from-[#070a10] to-[#0b0f17] py-20"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-gradient-to-tr from-accent/18 via-emerald-500/10 to-transparent blur-3xl" />
      </div>

      <div className="max-w-6xl mx-auto px-6 relative">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs tracking-[0.22em] uppercase text-gray-400">Resume</p>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-white tracking-tight">
            Experience &amp; Education
          </h2>
          <p className="mt-4 text-sm md:text-base text-gray-400 max-w-2xl mx-auto leading-relaxed">
            My professional journey so far.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Left: Experience */}
          <div>
            <h3 className="text-white font-semibold text-lg tracking-tight mb-6">Experience</h3>
            <div className="space-y-6">
              {experience.map((item) => {
                const tags = toTags(item.techStack);
                return (
                  <article
                    key={item.id}
                    className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur p-6 space-y-2 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-accent/40"
                  >
                    <h4 className="text-white font-semibold text-lg leading-snug">
                      {item.title}
                    </h4>
                    <p className="text-sm text-white/80">
                      {item.subtitle}
                      {item.date ? <span className="text-white/50"> • {item.date}</span> : null}
                    </p>
                    <p className="text-sm text-gray-400 leading-relaxed">
                      {item.description}
                    </p>

                    {tags.length > 0 && (
                      <div className="pt-2 flex flex-wrap gap-2">
                        {tags.map((t) => (
                          <span
                            key={`${item.id}-${t}`}
                            className="px-2 py-1 text-xs rounded-full bg-white/10 text-gray-200 border border-white/10"
                          >
                            {t}
                          </span>
                        ))}
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          </div>

          {/* Right: Education */}
          <div>
            <h3 className="text-white font-semibold text-lg tracking-tight mb-6">Education</h3>
            <div className="space-y-6">
              {education.map((item) => (
                <article
                  key={item.id}
                  className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur p-6 space-y-2 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-accent/40"
                >
                  <h4 className="text-white font-semibold text-lg leading-snug">
                    {item.title}
                  </h4>
                  <p className="text-sm text-white/80">
                    {item.subtitle}
                    {item.date ? <span className="text-white/50"> • {item.date}</span> : null}
                  </p>
                  {item.description ? (
                    <p className="text-sm text-gray-400 leading-relaxed">{item.description}</p>
                  ) : null}
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Resume